import aggiungi from  './aggiungi'

export default [
  // always
  {
    'key': 'listini-button-aggiungi',
    'label': 'AGGIUNGI LISTINO',
    'classCss': 'p-button-secondary',
    'icon':'pi pi-plus',
    'type': 'operation',
    'method': aggiungi,
    'display': 'always'
  },
]
